module.exports = __webpack_public_path__ + "static/media/7.a4b74a63.jpeg";